import { RouteObject } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import AccountType from "../pages/Auth-Pages/AccountType";
import ChosenFacility from "../pages/Auth-Pages/ChosenFacility";
import CongratsPage from "../pages/Auth-Pages/CongratsPage";
import CreatePassword from "../pages/Auth-Pages/CreatePassword";
import ForgetPassword from "../pages/Auth-Pages/ForgetPassword";
import Login from "../pages/Auth-Pages/Login";
import Register from "../pages/Auth-Pages/Register";
import VerifyOtp from "../pages/Auth-Pages/VerifyOtp";
import InternalServerErrorPage from "../pages/ErrorPages/InternalServerErrorPage";
import AuthGuard from "./AuthGuard";
import ErrorPage from "../pages/ErrorPages/ErrorPage";

export const AuthRoutes: RouteObject[] = [
  {
    path: "login",
    element: (
      <AuthLayout>
        <Login />
      </AuthLayout>
    ),
  },
  {
    path: "register",
    element: (
      <AuthLayout>
        <Register />
      </AuthLayout>
    ),
  },

  {
    path: "forget-password",
    element: (
      <AuthLayout>
        <AuthGuard>
          <ForgetPassword OriginType="auth" />
        </AuthGuard>
      </AuthLayout>
    ),
  },

  {
    path: "otp",
    element: (
      <AuthLayout>
        <AuthGuard>
          <VerifyOtp OriginType="auth" />
        </AuthGuard>
      </AuthLayout>
    ),
  },
  {
    path: "create-password",
    element: (
      <AuthLayout>
        <AuthGuard>
          <CreatePassword OriginType="auth" />
        </AuthGuard>
      </AuthLayout>
    ),
  },
  {
    path: "facility-type",
    element: (
      <AuthLayout>
        <AuthGuard>
          <AccountType OriginType="auth" />
        </AuthGuard>
      </AuthLayout>
    ),
  },
  {
    path: "chosen-facility",
    element: (
      <AuthLayout>
        <AuthGuard>
          <ChosenFacility OriginType="auth" />
        </AuthGuard>
      </AuthLayout>
    ),
  },
  {
    path: "congrats",
    element: (
      <AuthLayout>
        <AuthGuard>
          <CongratsPage />
        </AuthGuard>
      </AuthLayout>
    ),
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "500",
    element: <InternalServerErrorPage />,
  },
];
